import { useEffect } from 'react';

const BodyHeightListener = () => {
  useEffect(() => {
    const handleResize = () => {
      // console.log('handleResize', document.body.clientHeight);
      // send over the height to the parent
      window.parent.postMessage({
        type: 'setHeight',
        height: document.body.clientHeight
      }, '*');
    };

    window.addEventListener('resize', handleResize);

    // Optional: Use ResizeObserver for more precise detection
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(document.body);

    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
    };
  }, []);

  return null;
};

export default BodyHeightListener;